.arrow-icon {
  width: 12px;
  height: 12px;
}
